import { fetch } from '../utils/appUtils';
import { IS_WEB } from './appConstants';

export async function createWarrior(login: string, quick: boolean = false) {
  let invitedBy: string | undefined;
  if (IS_WEB) {
    try {
      invitedBy = window.localStorage.getItem('invitedBy') || undefined;
    } catch (e) {
      invitedBy = undefined;
    }
  }
  await fetch('/createWarrior', { login, quick, ...(invitedBy ? { invitedBy } : {}) });
  if (IS_WEB && invitedBy) {
    try {
      window.localStorage.removeItem('invitedBy');
    } catch (e) {
      // ignore
    }
  }
}

export async function increaseParameter(name: string) {
  await fetch('/increaseParameter', { name });
}

export async function increaseAbility(name: string) {
  await fetch('/increaseAbility', { name });
}

export async function increaseSkill(id: string) {
  await fetch('/increaseSkill', { id });
}

export async function dressUndressThing(dress: boolean, id: string) {
  await fetch('/dressUndressThing', { dress, id });
}

export async function applyThing(id: string) {
  await fetch('/applyThing', { id });
}

export async function undressThings() {
  await fetch('/undressThings');
}

export async function removeThing(id: string) {
  await fetch('/removeThing', { id });
}

export async function putInCombat(id: string) {
  await fetch('/putInCombat', { id });
}

export async function attack(warriorId: string, strikes: number[], blocks: number[]) {
  await fetch('/attack', {
    warriorId,
    strikes: JSON.stringify(strikes),
    blocks: JSON.stringify(blocks),
  });
}

export async function timeout() {
  await fetch('/timeout');
}

export async function quitFromCombat() {
  await fetch('/quitFromCombat');
}

export async function cleanBotsFromCombat() {
  await fetch('/cleanBotsFromCombat');
}

export async function buildingAction(id: string, actionName: string, params: {} = {}) {
  await fetch('/buildingAction', {
    id,
    actionName,
    params: JSON.stringify(params),
  });
}

export async function joinCombat(id: string, team: number) {
  await fetch('/joinCombat', { id, team });
}

export async function checkWarrior() {
  await fetch('/checkWarrior');
}

export async function sendAction(name: string, data: {} = {}) {
  const result = await fetch('/action', { actionName: name, data }, 'post');
  return result;
}

export async function deleteAccount() {
  await sendAction('deleteAccount');
}

export async function findArenaMatch() {
  return sendAction('findArenaMatch');
}

export async function addLoginLog() {
  await sendAction('addLoginLog');
}

export async function settledBonus(index: number) {
  await sendAction('settledBonus', { index });
}

export async function settledBonusAd(index: number) {
  await sendAction('settledBonusAd', { index });
}

export async function checkQuests() {
  await sendAction('checkQuests');
}

export async function addFriend(warriorId: string) {
  await sendAction('addFriend', { warriorId });
}

export async function awardAdView() {
  await sendAction('awardAdView');
}

export async function createClan(name: string, tag: string) {
  return sendAction('createClan', { name, tag });
}

export async function inviteToClan(warriorId: string) {
  return sendAction('inviteToClan', { warriorId });
}

export async function acceptClanInvite(clanId: string) {
  return sendAction('acceptClanInvite', { clanId });
}

export async function declineClanInvite(clanId: string) {
  return sendAction('declineClanInvite', { clanId });
}

export async function leaveClan() {
  return sendAction('leaveClan');
}

export async function kickFromClan(warriorId: string) {
  return sendAction('kickFromClan', { warriorId });
}

export async function disbandClan() {
  return sendAction('disbandClan');
}

export async function declareWar(enemyName: string) {
  return sendAction('declareWar', { enemyName });
}

export async function joinWar() {
  return sendAction('joinWar');
}

export async function startWar() {
  return sendAction('startWar');
}

export async function cancelWar() {
  return sendAction('cancelWar');
}

export async function validateAppleReceipt(
  params: { productId: string; receipt: string; buildingId?: string } & Record<string, any>,
) {
  return sendAction('validateAppleReceipt', params);
}
